var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "dialog",
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.receivingOutsideWarehouse"),
        width: "1055px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "app-main-content" }, [
        _c("div", { staticClass: "details-view" }, [
          _c("div", { staticClass: "main-content" }, [
            _c(
              "div",
              { staticClass: "section" },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BasicInfo")))
                ]),
                _c(
                  "el-form",
                  { attrs: { inline: true, "label-width": "80px" } },
                  [
                    _c(
                      "el-form-item",
                      [
                        _c("span", { staticClass: "blue" }, [
                          _vm._v(_vm._s(_vm.$t("queryJob.warehousingTime")))
                        ]),
                        _c("el-date-picker", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            no: "warehouseInDate",
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            clearable: ""
                          },
                          model: {
                            value: _vm.warehouseIn.warehouseInDate,
                            callback: function($$v) {
                              _vm.$set(_vm.warehouseIn, "warehouseInDate", $$v)
                            },
                            expression: "warehouseIn.warehouseInDate"
                          }
                        }),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { margin: "0 10px" },
                            model: {
                              value: _vm.warehouseIn.broken,
                              callback: function($$v) {
                                _vm.$set(_vm.warehouseIn, "broken", $$v)
                              },
                              expression: "warehouseIn.broken"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("queryJob.damagedAndDamp")))]
                        ),
                        _c("el-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            no: "brokenQuantity",
                            disabled: !_vm.warehouseIn.broken,
                            "controls-position": "right",
                            precision: 0,
                            min: 0,
                            max: 9999
                          },
                          model: {
                            value: _vm.warehouseIn.brokenQuantity,
                            callback: function($$v) {
                              _vm.$set(_vm.warehouseIn, "brokenQuantity", $$v)
                            },
                            expression: "warehouseIn.brokenQuantity"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section" },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("queryJob.size")))
                ]),
                _c("warehouse-detail-grid", {
                  ref: "detailGrid",
                  attrs: {
                    context: {},
                    action: "look",
                    job: _vm.job,
                    "warehouse-in": _vm.warehouseIn,
                    "display-summary": false
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section" },
              [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("queryJob.photo")))
                ]),
                _c("warehouse-pic-grid", {
                  ref: "picGrid",
                  attrs: { model: _vm.warehouseIn, "show-buttons": false },
                  on: { uploadDone: _vm.uploadDoneHandler }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "span",
        {
          staticStyle: { display: "flex" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { no: "selectPhotos", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.$refs.picGrid.selectHandler()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.selectPhotos")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "deletePhotos", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.$refs.picGrid.deleteHandler()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.deletePhotos")))]
          ),
          _c("div", { staticStyle: { "flex-grow": "1" } }),
          _c(
            "el-button",
            {
              attrs: { no: "Confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }